import { Injectable } from '@angular/core';
import { ApiService } from '../..';
import { UserService } from '../../common/user.service';

@Injectable()
export class CauHinhNhanService {

  constructor(private api: ApiService, private user: UserService) { }
  getAll_LoaiCanhBao() {
    var param = {
      config: JSON.stringify({ namesql: "PKG_CANHBAO.P_LAYDS_LOAICANHBAO" }),
      para: ""
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }


  authorize(email, phone) {
    let param = {
      "email": email,
      "phone": phone,
    };
    return this.api.Excute("api/Authorize/SendEmailOrSMS", param);
  }

  confirm(email, validNumberEmail, phone, validNumberPhone) {
    var param = {
      "config": '{"namesql":"PKG_CANHBAO.P_XACTHUC"}',
      "para": '{"v_EMAIL":"' + email + '","v_MAXACTHUC_EMAIL":"' + validNumberEmail + '","v_SODIENTHOAI":"' + phone + '","v_MAXACTHUC_DIENTHOAI":"' + validNumberPhone + '"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }

  xoaCauHinhNhan(idCanhBao) {
    let curUs = this.user.getCurrentUser();
    var param = {
      "config": '{"namesql":"PKG_CANHBAO.P_XOA_CAUHINHNHAN"}',
      "para": '{"v_IDCAUHINH":"' + idCanhBao + '","v_MATAIKHOAN":"' + curUs.mataikhoan + '"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }

  insertCauHinhNhan(email, emailcc, phone, phonecc, danhmucid, maloaicanhbao, tentuyen, listtuyen) {
    let curUs = this.user.getCurrentUser();
    let param = {
      "email": email,
      "emailcc": emailcc,
      "sodienthoai": phone,
      "sodienthoaicc": phonecc,
      "danhmucid": danhmucid,
      "listloaicanhbao": maloaicanhbao,
      "mataikhoan": curUs.mataikhoan,
      "tentuyen": tentuyen,
      "listtuyen": listtuyen
    };
    return this.api.Excute("api/Authorize/SaveCauHinhNhan", param);
  }


  layDanhSachCauHinhNhan(danhmucid, maloaicanhbao, sotrang, sodong) {
    var param = {
      "config": '{"namesql":"PKG_CANHBAO.P_LAYDS_CAUHINHNHAN"}',
      "para": '{"v_DANHMUCID":"' + danhmucid + '","v_MALOAICANHBAO":"' + maloaicanhbao + '","v_SOTRANG":"' + sotrang + '","v_SODONG":"' + sodong + '"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  // luuTuyenDiemDo(listDiemDo) {
  //   var param = {
  //     "config": '{"namesql":"PKG_CANHBAO.P_LUU_TUYENDIEMDO"}',
  //     "para": '{"v_LISTDIEMDO":"' + listDiemDo + '"}'
  //   };
  //   return this.api.Excute("api/ExcuteOracle", param);
  // }

  // xoa(id) {
  //   var param = {
  //     "config": '{"namesql":"PKG_CANHBAO.P_XOA_CAUHINHNHAN"}',
  //     "para": '{"v_ID":"' + id + '"}'
  //   };
  //   return this.api.Excute("api/ExcuteOracle", param);
  // }

}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/canh-bao/cau-hinh-nhan/cauhinhnhan.service.ts